/**
 * @generated SignedSource<<212f07bc6cf16459e2972ce954799a70>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PublicTemplateQuery$variables = Record<PropertyKey, never>;
export type PublicTemplateQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PublicTemplate_query">;
};
export type PublicTemplateQuery = {
  response: PublicTemplateQuery$data;
  variables: PublicTemplateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "PublicTemplateQuery",
    "selections": [
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "PublicTemplate_query"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "PublicTemplateQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Candidate",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      },
      {
        "alias": "company",
        "args": null,
        "concreteType": "Company",
        "kind": "LinkedField",
        "name": "companyDomainName",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nameFriendly",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "File",
            "kind": "LinkedField",
            "name": "logo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": [
                  {
                    "kind": "Literal",
                    "name": "fitIn",
                    "value": true
                  }
                ],
                "kind": "ScalarField",
                "name": "url",
                "storageKey": "url(fitIn:true)"
              },
              (v0/*: any*/)
            ],
            "storageKey": null
          },
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "features",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c3ca2e56ab44285991f6259e6b64f8e1",
    "id": null,
    "metadata": {},
    "name": "PublicTemplateQuery",
    "operationKind": "query",
    "text": "query PublicTemplateQuery {\n  ...PublicTemplate_query\n}\n\nfragment HeaderLogo_company on Company {\n  nameFriendly\n  logo {\n    url(fitIn: true)\n    id\n  }\n}\n\nfragment PublicTemplate_query on Query {\n  me {\n    id\n  }\n  company: companyDomainName {\n    ...HeaderLogo_company\n    id\n    name\n    features\n  }\n}\n"
  }
};
})();

(node as any).hash = "5eb80fff5569fa53dbb04e9fe96cabc0";

export default node;
